module.exports = __webpack_public_path__ + "media/images/site/visao-9769e0c0f6403cd2c8724a4ad84e3e14.jpg";